<template>
  <b-button
    class="download-button"
    variant="primary"
    size="lg"
    @click="$emit('triggerDownload', type)"
  >
    <LoadingCard
      style="display:inline-block;"
      v-if="loading.loading && loading.type === type"
    ></LoadingCard>
    <i v-else :class="icon" aria-hidden="true"></i>
    {{ name }}
  </b-button>
</template>
<script>
import LoadingCard from "../shared/LoadingCard.vue";

export default {
  name: "CustomButton",
  props: ["type", "name", "loading", "icon"],
  data() {
    return {};
  },
  components: { LoadingCard },
  methods: {}
};
</script>

<style>
.download-button {
  display: block;
  margin: auto;
  font-weight: 600;
  padding: 0.6em;
}
/* fa-file-excel-o used for dynamic buttons - icon props */
.fa-file-excel-o {
  font-size: 1.4em;
  color: #ffffff68;
  transform: rotate(30deg);
  padding-right: 0.5em;
}
/* sk-double-bounce used for dynamic buttons - loading */
.sk-double-bounce {
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}
</style>
